
const yakitDurumuOptions = [
    {
        value: 0,
        text: "Yok"
    },
    {
        value: 1,
        text: "Var(% Olarak)"
    },
    {
        value: 2,
        text: "Var(TL Olarak)"
    }
]


export default yakitDurumuOptions